// @flow

// Libs
import _get from 'lodash/get'

// Utils
import createReducer from 'fc-utils/createReducer'

// constants
import {
  BORDER_UPLOADED,
} from './constants'

import {
  BRANCH,
} from 'fc-assets'

// InitialState
import initialState from './initialState'

// Reducers
import reducers from 'fc-assets/src/reducers'

// Exports
export default createReducer(initialState, {
  ...reducers,
  [BORDER_UPLOADED]: (state: Object, {assetId, response}: {assetId: number, response: Object}): Object => {
    const parsedShapeData = JSON.parse(response.shapeData)
    const features = _get(parsedShapeData, 'features', [])

    return {
      ...state,
      [BRANCH]: {
        ...state[BRANCH],
        [assetId]: {
          ...state.assets[assetId],
          shape: {
            ...response,
            shapeData: {
              ...parsedShapeData,
              features: features.map((feature: Object, featureIndex: number): Object => {
                return {
                  ...feature,
                  properties: {
                    ...feature.properties,
                    featureIndex,
                  },
                }
              }),
            },
          },
        },
      },
    }
  },
})
